export default "__VITE_ASSET__oq4Ojl32__"